import React from 'react';
import { Card, Typography, List, Button, Row, Col } from 'antd';
import {
  EnvironmentOutlined,
  FileSearchOutlined,
  CheckCircleOutlined,
  PhoneOutlined,
} from '@ant-design/icons';
import { shopConfig } from '../../config/shop.config';

const { Title, Text, Paragraph } = Typography;

const PrePurchaseSection: React.FC = () => {
  const handleCallClick = () => {
    window.location.href = `tel:${shopConfig.phone}`;
  };

  return (
    <div style={{ padding: '80px 20px', backgroundColor: '#f9fafb' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        <Row gutter={[48, 32]} align="middle">
          {/* Left Column - Info */}
          <Col xs={24} lg={14}>
            <div
              style={{
                width: '70px',
                height: '70px',
                backgroundColor: '#dbeafe',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginBottom: '24px',
              }}
            >
              <FileSearchOutlined style={{ fontSize: '32px', color: '#2563eb' }} />
            </div>

            <Title level={2} style={{ marginBottom: '16px' }}>
              {shopConfig.prePurchaseInspection.title}
            </Title>

            <Paragraph style={{ fontSize: '18px', color: '#4b5563', marginBottom: '32px' }}>
              {shopConfig.prePurchaseInspection.description}
            </Paragraph>

            <List
              dataSource={shopConfig.prePurchaseInspection.features}
              renderItem={(item) => (
                <List.Item style={{ border: 'none', padding: '12px 0' }}>
                  <CheckCircleOutlined
                    style={{ color: '#10b981', fontSize: '20px', marginRight: '16px' }}
                  />
                  <Text style={{ fontSize: '16px' }}>{item}</Text>
                </List.Item>
              )}
            />
          </Col>

          {/* Right Column - Pricing Card */}
          <Col xs={24} lg={10}>
            <Card
              style={{
                borderRadius: '16px',
                border: '2px solid #2563eb',
                boxShadow: '0 10px 40px rgba(37, 99, 235, 0.15)',
              }}
            >
              <div style={{ textAlign: 'center' }}>
                <EnvironmentOutlined
                  style={{ fontSize: '48px', color: '#2563eb', marginBottom: '16px' }}
                />

                <Title level={3} style={{ marginBottom: '8px' }}>
                  We Come To You
                </Title>

                <div style={{ margin: '24px 0' }}>
                  <Text type="secondary" style={{ fontSize: '16px' }}>
                    Starting at
                  </Text>
                  <div>
                    <Text
                      style={{
                        fontSize: '48px',
                        fontWeight: 'bold',
                        color: '#2563eb',
                        lineHeight: 1,
                      }}
                    >
                      ${shopConfig.prePurchaseInspection.startingPrice}
                    </Text>
                  </div>
                  <Text type="secondary" style={{ fontSize: '14px' }}>
                    Price varies by location
                  </Text>
                </div>

                <Button
                  type="primary"
                  size="large"
                  block
                  icon={<PhoneOutlined />}
                  onClick={handleCallClick}
                  style={{
                    height: '50px',
                    fontSize: '16px',
                    fontWeight: 600,
                    borderRadius: '8px',
                    marginTop: '16px',
                  }}
                >
                  Call to Schedule
                </Button>

                <Text
                  type="secondary"
                  style={{ fontSize: '14px', display: 'block', marginTop: '16px' }}
                >
                  Get expert advice before you buy
                </Text>
              </div>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default PrePurchaseSection;
